import { render, staticRenderFns } from "./RegisterHotel.vue?vue&type=template&id=4f69446a&scoped=true&"
import script from "./RegisterHotel.vue?vue&type=script&lang=js&"
export * from "./RegisterHotel.vue?vue&type=script&lang=js&"
import style0 from "./RegisterHotel.vue?vue&type=style&index=0&id=4f69446a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f69446a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VCol,VForm})
